module.exports = __webpack_public_path__ + "img/9788997980987.07ae38fb.jpg";